import { 
  SAVE_CLIENT_STATS_GRAPH,
  CLIENT_STATS_API_LOADING
 } from "../../constants/graphConstants/connectedClientsGraphConstants";

 export const clientStatsGraphReducer = (
   state = { 
      loading : false,
      appUsage : [],
      performance : []
    },
    action
  ) => {
    switch (action.type) {
        case CLIENT_STATS_API_LOADING:
          return {
            ...state,
            appUsage : [],
            performance : [],
            loading: action.payload,
          };
        case SAVE_CLIENT_STATS_GRAPH:
          return {
            ...state,
            loading: false,
            ...action.payload,
          };
        default:
          return state;
      }
 }